// frontend/src/components/ReservationModal.jsx
import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function ReservationModal({ show, onClose, onSuccess }) {
    const [sectors, setSectors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        origin: 'Pronto-Socorro',
        patient_gender: 'Masculino',
        patient_condition: 'Estável',
        patient_precautions: 'Nenhuma', // [Nova]
        sector_id: '',
        bed_type: 'Clínico',
        priority: 'Normal', // Normal, Alta, Urgente
        justification: '',
        scheduled_date: new Date().toISOString().split('T')[0] // [Novo] Default: Hoje
    });

    useEffect(() => {
        if (show) {
            fetchSectors();
        }
    }, [show]);

    const fetchSectors = async () => {
        try {
            const response = await api.get('/sectors');
            setSectors(response.data);
        } catch (error) {
            console.error('Erro ao buscar setores:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post('/reservations', formData);
            alert('Reserva solicitada com sucesso!');
            if (onSuccess) onSuccess();
            onClose();
        } catch (error) {
            console.error('Erro ao criar reserva:', error);
            alert('Erro ao criar reserva: ' + (error.response?.data?.error || error.message));
        } finally {
            setLoading(false);
        }
    };

    if (!show) return null;

    return (
        <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header bg-warning text-dark">
                        <h5 className="modal-title"><i className="bi bi-clock-history me-2"></i>Nova Solicitação de Reserva (NIR)</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            {/* Origem e Prioridade */}
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">Origem da Demanda</label>
                                    <select
                                        className="form-select"
                                        value={formData.origin}
                                        onChange={e => setFormData({ ...formData, origin: e.target.value })}
                                    >
                                        <option value="Pronto-Socorro">Pronto-Socorro</option>
                                        <option value="Transferência Interna">Transferência Interna</option>
                                        <option value="Transferência Externa">Transferência Externa</option>
                                        <option value="Cirurgia Eletiva">Cirurgia Eletiva</option>
                                        <option value="Internação Eletiva">Internação Eletiva</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Prioridade</label>
                                    <select
                                        className="form-select"
                                        value={formData.priority}
                                        onChange={e => setFormData({ ...formData, priority: e.target.value })}
                                    >
                                        <option value="Normal">Normal (até 4h)</option>
                                        <option value="Alta">Alta (até 1h)</option>
                                        <option value="Urgente">Urgente (Imediato)</option>
                                    </select>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">Nome do Paciente (Opcional)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Ex: João Silva (ou deixar em branco)"
                                        value={formData.patient_name || ''}
                                        onChange={e => setFormData({ ...formData, patient_name: e.target.value })}
                                    />
                                    <div className="form-text text-muted">
                                        Use apenas se tiver certeza. Se vazio, permanece anônimo.
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-bold">Data Prevista (Agendamento)</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={formData.scheduled_date}
                                        onChange={e => setFormData({ ...formData, scheduled_date: e.target.value })}
                                        required
                                    />
                                </div>
                            </div>

                            {/* Perfil do Paciente */}
                            <h6 className="mt-4 mb-3 border-bottom pb-2">Perfil do Paciente (Anônimo)</h6>
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <label className="form-label">Sexo</label>
                                    <select
                                        className="form-select"
                                        value={formData.patient_gender}
                                        onChange={e => setFormData({ ...formData, patient_gender: e.target.value })}
                                    >
                                        <option value="Masculino">Masculino</option>
                                        <option value="Feminino">Feminino</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">Condição</label>
                                    <select
                                        className="form-select"
                                        value={formData.patient_condition}
                                        onChange={e => setFormData({ ...formData, patient_condition: e.target.value })}
                                    >
                                        <option value="Estável">Estável</option>
                                        <option value="Clínica">Clínica</option>
                                        <option value="Cirúrgica">Cirúrgica</option>
                                        <option value="Crítica">Crítica</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label className="form-label">Precauções</label>
                                    <select
                                        className="form-select"
                                        value={formData.patient_precautions}
                                        onChange={e => setFormData({ ...formData, patient_precautions: e.target.value })}
                                    >
                                        <option value="Nenhuma">Nenhuma</option>
                                        <option value="Contato">Contato</option>
                                        <option value="Gotículas">Gotículas</option>
                                        <option value="Aerossóis">Aerossóis</option>
                                        <option value="Multirresistente">Multirresistente</option>
                                    </select>
                                </div>
                            </div>

                            {/* Destino */}
                            <h6 className="mt-4 mb-3 border-bottom pb-2">Destino Desejado</h6>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">Setor Alvo (Principal)</label>
                                    <div className="input-group">
                                        <select
                                            className="form-select"
                                            value={formData.sector_id}
                                            onChange={e => setFormData({ ...formData, sector_id: e.target.value })}
                                            required
                                        >
                                            <option value="">Selecione o setor principal...</option>
                                            {sectors.map(s => (
                                                <option key={s.id} value={s.id}>{s.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="form-text text-muted">
                                        * Se houver opções secundárias, indique na justificativa.
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Tipo de Leito</label>
                                    <select
                                        className="form-select"
                                        value={formData.bed_type}
                                        onChange={e => setFormData({ ...formData, bed_type: e.target.value })}
                                    >
                                        <option value="Clínico">Clínico</option>
                                        <option value="Enfermaria">Enfermaria</option>
                                        <option value="Semi-intensiva">Semi-intensiva</option>
                                        <option value="UTI">UTI</option>
                                    </select>
                                </div>
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Justificativa (Opcional)</label>
                                <textarea
                                    className="form-control"
                                    rows="2"
                                    value={formData.justification}
                                    onChange={e => setFormData({ ...formData, justification: e.target.value })}
                                ></textarea>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                                <button type="submit" className="btn btn-warning" disabled={loading}>
                                    {loading ? 'Salvando...' : 'Solicitar Reserva'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
